module.exports = __webpack_public_path__ + "img/13.9d9f6361.jpg";